export default "__VITE_ASSET__BQs3DTjS__"